module.exports = Vuex;


//////////////////
// WEBPACK FOOTER
// external "Vuex"
// module id = 2
// module chunks = 138